import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import PSTVue from "../../asstes/pstvue.png";
import { HiChevronDown, HiMenu, HiX } from "react-icons/hi";

const originalMenuItems = [
  {
    label: "About Us",
    submenu: [
      { name: "Mission", href: "/pstvue/mission" },
      { name: "Testimonials", href: "#testimonial" },
    ],
  },
  {
    label: "Apps",
    submenu: [
      { name: "Parent", href: "/pst-apps/parent" },
      { name: "Student", href: "/pst-apps/student" },
      { name: "Teacher", href: "/pst-apps/teacher" },
    ],
  },
  {
    label: "Portals",
    submenu: [
      { name: "Parent", href: "/portals/parent" },
      { name: "Student", href: "/portals/student" },
      { name: "Teacher", href: "/portals/teacher" },
    ],
  },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const location = useLocation(); // ✅ Get current path

  const toggleSubmenu = (label) => {
    setOpenSubmenu(openSubmenu === label ? null : label);
  };

  // ✅ Filter submenu based on current path
  // const menuItems = originalMenuItems.map((item) => {
  //   if (item.label === "About Us") {
  //     return {
  //       ...item,
  //       submenu: item.submenu.filter(
  //         (sub) =>
  //           !(location.pathname === "/pstvue/mission" && sub.name === "Testimonials")
  //       ),
  //     };
  //   }
  //   return item;
  // });

  // Show Testimonials ONLY on dashboard
  const allowTestimonials =
    location.pathname === "/pstvue" || location.pathname === "/dashboard";

  const menuItems = originalMenuItems.map((item) => {
    if (item.label === "About Us") {
      return {
        ...item,
        submenu: item.submenu.filter(
          (sub) => !(sub.name === "Testimonials" && !allowTestimonials)
        ),
      };
    }
    return item;
  });

  return (
    <header className="bg-[#04254d]">
      <nav className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 flex items-center justify-between h-20">
        <a href="/pstvue">
          <img src={PSTVue} alt="PSTVue" className="w-30 h-12 cursor-pointer" />
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center space-x-8 text-white text-base font-medium">
          {menuItems.map((item) => (
            <li key={item.label} className="relative group cursor-pointer">
              <button className="flex items-center space-x-1 hover:underline">
                <span>{item.label}</span>
                <HiChevronDown className="w-4 h-4" />
              </button>

              {/* Dropdown */}
              <ul className="absolute left-0 mt-2 w-40 bg-white text-slate-800 shadow-md rounded-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                {item.submenu.map((sub) => (
                  <li
                    key={sub.name}
                    className="px-4 py-2 hover:bg-gray-100 text-sm"
                  >
                    <a href={sub.href}>{sub.name}</a>
                  </li>
                ))}
              </ul>
            </li>
          ))}

          <li className="hover:underline">
            <a href="/pstvue-subscription">Subscription</a>
          </li>
          <li className="hover:underline">
            <a href="/pstvue-data-privacy">Data Privacy</a>
          </li>
          <li>
            <a
              href="/contact"
              onClick={() => setIsOpen(false)}
            >
              Contact Us
            </a>
          </li>
        </ul>

        {/* Sign In */}
        <a
         href={`${process.env.REACT_APP_FRONTEND_URL}/login`}
        // href="/login"
          className="ml-4 bg-[#ffb62c] text-[#1a1a1a] text-base font-semibold rounded-lg px-5 py-3 hover:bg-[#f0a800] transition"
        >
          Sign In
        </a>

        <a
         href={`${process.env.REACT_APP_FRONTEND_URL}/signup`}
        // href="/signup"
          className="ml-4 bg-[#ffb62c] text-[#1a1a1a] text-base font-semibold rounded-lg px-5 py-3 hover:bg-[#f0a800] transition"
        >
          Sign Up
        </a>

        {/* Hamburger */}
        <button
          className="ml-4 md:hidden text-white"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? (
            <HiX className="w-7 h-7" />
          ) : (
            <HiMenu className="w-7 h-7" />
          )}
        </button>
      </nav>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-blue-500/20 text-white px-6 py-4">
          <ul className="space-y-4 text-base font-medium">
            {menuItems.map((item) => (
              <li key={item.label}>
                <button
                  onClick={() => toggleSubmenu(item.label)}
                  className="flex items-center justify-between w-full"
                >
                  <span>{item.label}</span>
                  <HiChevronDown
                    className={`w-4 h-4 transform transition-transform ${
                      openSubmenu === item.label ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {openSubmenu === item.label && (
                  <ul className="pl-4 mt-2 space-y-2">
                    {item.submenu.map((sub) => (
                      <li key={sub.name}>
                        <a
                          href={sub.href}
                          onClick={() => setIsOpen(false)}
                          className="block"
                        >
                          {sub.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
            <li>
              <a href="/pstvue-subscription" onClick={() => setIsOpen(false)}>
                Subscription
              </a>
            </li>
            <li>
              <a href="/pstvue-data-privacy" onClick={() => setIsOpen(false)}>
                Data Privacy
              </a>
            </li>
            <li>
              <a
                href="https://www.mnrtechnologies.com/contact"
                onClick={() => setIsOpen(false)}
              >
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
